import { useCallback } from 'react';

import { isDefined } from 'utils/tsHelpers';
import { insertInArray } from 'utils/helpers';
import { useCriteriaRequirementsState } from '../criteria';
import { createBlankRequirement } from '../../utils';
import { useRequirementState } from './useRequirementState';
import { useQueryStateContext } from '../../contexts';
import { useCurrentRequirementIndex } from './useCurrentRequirementIndex';

export const useDuplicateRequirement = () => {
  const { requirement } = useRequirementState();
  const { setToLatestId } = useQueryStateContext();
  const { setRequirements } = useCriteriaRequirementsState();
  const index = useCurrentRequirementIndex();

  return useCallback(() => {
    const newRequirement = createBlankRequirement({ ...requirement });
    setRequirements((requirements) => {
      if (!isDefined(index)) {
        [...requirements, newRequirement];
      }
      return insertInArray([...requirements], index + 1, newRequirement);
    });
    setToLatestId(newRequirement.id);
  }, [setRequirements, JSON.stringify(requirement), setToLatestId]);
};
